import { render, staticRenderFns } from "./UpdatesTable.vue?vue&type=template&id=e63e3aee&scoped=true"
import script from "./UpdatesTable.vue?vue&type=script&lang=js"
export * from "./UpdatesTable.vue?vue&type=script&lang=js"
import style0 from "./UpdatesTable.vue?vue&type=style&index=0&id=e63e3aee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63e3aee",
  null
  
)

export default component.exports